import React, {useState, useRef, useEffect} from 'react'
import { useHistory } from 'react-router-dom'
import '@/assets/css/news.scss';
import {REQUEST} from "@/api";
import intl from 'react-intl-universal';
import {langPath} from "../../util";
const News = () => {
    const [offset, setOffset] = useState(10)
    const [style1, setStyle1] = useState({})
    const [newsList, setNewsList] = useState(null)

    const scrollBox = useRef()
    const history = useHistory()

    const aniScroll = () => {
        const scroll = scrollBox.current
        if (scroll) {
            if (Math.abs(offset) >= scroll.scrollWidth) {
                setOffset(0)
            }
            else {
                let step = -1
                setOffset(offset => offset + step)
                setStyle1({
                    transform: `translate3d(${offset}px, 0, 0)`
                })
            }
        }
    }
    const fetchGetNewsList = () => {
        REQUEST('newsList', {
            type: intl.getInitOptions().currentLocale === 'zh-CN' ? '1' : '2',
            page: 1,
            limit: 20,
            shelves: '1'
        }).then((res) => {
            // console.log(res.body.list)
            setNewsList(resetList(res.body.list))
        })
        function resetList(arr = []) {
            const obj = {}
            for (let i = 1; i <= 6; i++) {
                for (let j = 0; j < arr.length; j++) {
                    const item = arr[j]
                    // eslint-disable-next-line eqeqeq
                    if (item.newsAddress == i) {
                        obj['item' + i] = item
                        continue
                    }
                }
            }
            return obj
        }
    }
    const goDetail = (item) => {
        history.push(langPath(`/news/` + item.mark))
    }
    useEffect(() => {
        requestAnimationFrame(aniScroll)
    }, [offset])
    useEffect(() => {
        fetchGetNewsList()
    }, [])
    return (
        <div className="rl">
            <div className="rl-news rl-container">
                <div className="rl-news-head">
                    <div className="rl-news-brand flex-center">
                        # BRAND NEWS #
                    </div>
                    <div className="rl-news-scroll-box flex-row-start" ref={scrollBox}>
                        <div>
                            <div className="scroll-box flex-row-start" style={style1}>
                                <p className="rl-scroll-box-text">UNRESTRAINED UNINHIBITED & EGOTISTICAL; PURE WHITE SINCERE & IN</p>
                                <p className="rl-scroll-box-text">UNRESTRAINED UNINHIBITED & EGOTISTICAL; PURE WHITE SINCERE & IN</p>
                                <p className="rl-scroll-box-text">UNRESTRAINED UNINHIBITED & EGOTISTICAL; PURE WHITE SINCERE & IN</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="rl-news-content">
                    <div className="rl-news-item flex-between">
                        {
                            newsList && newsList.item1 && (
                                <div className="news-item" onClick={() => goDetail(newsList.item1)} >
                                    <img src="https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/news/01.jpg"alt=""/>
                                    <div className="btn-info">
                                        Read More
                                    </div>
                                </div>
                            )
                        }
                        <div className="news-item">
                            {
                                newsList && newsList.item2 && (
                                    <div className="news-info">
                                        <div className="info-head">
                                            <p>{newsList.item2.title}</p>
                                            {/*<p>{newsList.item2.title}</p>*/}
                                        </div>
                                        <div className="info-des">
                                            <p>{newsList.item2.subTitle} </p>
                                        </div>
                                    </div>
                                )
                            }

                        </div>
                    </div>
                    <div className="rl-news-item flex-between">
                        <div className="news-item">
                            {
                                newsList && newsList.item3 && (
                                    <div className="news-info">
                                        <div className="info-head">
                                            <p>{newsList.item3.title}</p>
                                        </div>
                                        <div className="info-des">
                                            <p>{newsList.item2.subTitle} </p>
                                        </div>
                                    </div>
                                )
                            }
                            {
                                newsList && newsList.item3 && (
                                    <div className="btn-info">
                                        Read More
                                    </div>
                                )
                            }
                        </div>
                        <div className="news-item">
                            <img src="https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/news/02.jpg" alt=""/>
                            {
                                newsList && newsList.item4 && (
                                <div className="news-info1 bg">
                                    <div className="info-head">
                                        <p>{newsList.item4.title}</p>
                                    </div>
                                    <div className="btn-info">
                                        Read More
                                    </div>
                                </div>)
                            }
                        </div>
                    </div>
                    <div className="rl-news-item o flex-between">
                        <div className="news-item left">
                            {
                                newsList && newsList.item5 && (
                                    <div className="news-info">
                                        <div className="info-head">
                                            <p>{newsList.item5.title}</p>
                                        </div>
                                        <div className="info-des">
                                            <p>{newsList.item5.subTitle} </p>
                                        </div>
                                    </div>)
                            }

                            <div className="btn-info">
                                Read More
                            </div>
                        </div>
                        <div className="news-item right">
                            {
                                newsList && newsList.item6 && (
                                    <div className="news-info">
                                        <div className="info-head">
                                            <p>{newsList.item6.title}</p>
                                        </div>
                                        <div className="info-des">
                                            <p>{newsList.item6.subTitle} </p>
                                        </div>
                                    </div>)
                            }
                            <div className="btn-info">
                                Read More
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default News
